import { render, staticRenderFns } from "./certbanner.vue?vue&type=template&id=8b092c52&scoped=true&"
import script from "./certbanner.vue?vue&type=script&lang=js&"
export * from "./certbanner.vue?vue&type=script&lang=js&"
import style0 from "./certbanner.vue?vue&type=style&index=0&id=8b092c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b092c52",
  null
  
)

export default component.exports